import React, { useState, useEffect } from "react";
import {
  IonCard,
  IonLabel,
  IonCardHeader,
  IonCardTitle,
  IonItem,
  IonButton,
} from "@ionic/react";
import SelectItem from "../../../components/formItems/SelectItem";
import InputItem from "../../../components/formItems/InputItem";
import { Controller } from "react-hook-form";

import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { addAsset } from "../patientSlice";
import { useForm } from "react-hook-form";

const FileUpload = (props) => {
  const { activePatient } = props;
  const [formValues, setFormValues] = useState(null);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { handleSubmit, control, watch, reset } = useForm({});

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      setFormValues(value);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onFinish = async (values) => {
    const params = {
      branchId: activePatient.branch,
      id: activePatient.id,
      file: values.file,
      params: values,
      resource: "patients",
    };
    const action = await dispatch(addAsset(params));
    if (!action.error) {
      reset();
    }
  };

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.file_upload",
          })}
        </IonCardTitle>
      </IonCardHeader>
      <form onSubmit={handleSubmit(onFinish)}>
        <IonItem lines="none">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <IonButton
              color="light"
              size="default"
              onClick={() => document.getElementById("getFile").click()}
            >
              {intl.formatMessage({
                id: "app.mobile.forms.patient.choose_file",
              })}
            </IonButton>
            {formValues && formValues.file && formValues.file.name && (
              <IonLabel style={{ padding: "0 10px" }}>
                <p>{formValues.file.name}</p>
              </IonLabel>
            )}
            <Controller
              control={control}
              render={({ field }) => {
                const { onChange } = field;
                return (
                  <input
                    type="file"
                    onChange={(ev) => onChange(ev.target.files[0])}
                    id="getFile"
                    style={{ display: "none" }}
                  />
                );
              }}
              name={"file"}
            />
          </div>
        </IonItem>
        <InputItem
          name="name"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.asset_name",
          })}
          rules={{
            required: `${intl.formatMessage({
              id: "app.mobile.forms.patient.asset_name",
            })} ${intl.formatMessage({
              id: "app.mobile.forms.requiredMessage",
            })}`,
          }}
        />
        <SelectItem
          name="category_id"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.asset_category",
          })}
          params={{
            name: "meta/system_tables/asset_categories",
          }}
          rules={{
            required: `${intl.formatMessage({
              id: "app.mobile.forms.patient.asset_category",
            })} ${intl.formatMessage({
              id: "app.mobile.forms.requiredMessage",
            })}`,
          }}
          identfierId="id"
        />

        <SelectItem
          name="sub_category_id"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.asset_sub_category",
          })}
          params={{
            name: "meta/system_tables/asset_sub_categories",
          }}
          rules={{
            required: `${intl.formatMessage({
              id: "app.mobile.forms.patient.asset_sub_categories",
            })} ${intl.formatMessage({
              id: "app.mobile.forms.requiredMessage",
            })}`,
          }}
          identfierId="id"
        />

        <div style={{ height: "10px" }} />
        <IonButton
          style={{ margin: "8px 16px", borderRadius: "10px" }}
          color="primary"
          expand="full"
          type="submit"
          disabled={
            !formValues ||
            !formValues.file ||
            !formValues.name ||
            !formValues.category_id ||
            !formValues.sub_category_id
          }
        >
          {intl.formatMessage({
            id: "app.mobile.actions.upload",
          })}
        </IonButton>
      </form>
    </IonCard>
  );
};

export default FileUpload;
